import { i18nKey } from './constants'

// Text the transaction humanizer (ambire-common `libs/humanizer` and ZKX `libs/zkxClearSigning`)
// shows to the user and that `yarn i18n:extract` cannot collect on its own: controllerMessages.mjs
// skips the humanizer folder, and ERC-7730 labels/intents live in descriptor JSON files. Listed
// here so extract adds them to en.json. humanizerMessages.test.ts fails when the humanizer starts
// producing a warning that is missing here, or a bundled descriptor uses a label/intent that is.

// Warnings (`call.warnings[].content`), translated with translateControllerMessage().
export const HUMANIZER_WARNING_MESSAGES = [
  i18nKey('This app can spend this token from your account with no limit. Continue only if you trust it.'),
  i18nKey(
    'This app can transfer any item you own from this collection, now or later. Continue only if you trust it.'
  ),
  i18nKey('The tokens from this transaction will be sent to another address, not to your account.'),
  i18nKey('This transaction will send {{nativeAssetSymbol}}'),
  i18nKey(
    'This request does not say who receives the tokens. Whoever submits it decides where the tokens go. Sign it only if you fully trust the app.'
  ),
  i18nKey(
    'This transaction hides many other transactions one inside another. This is unusual - continue only if you fully trust this app.'
  ),
  i18nKey(
    'This transaction also sends a separate payment to the address below as a "gas refund", on top of what is shown above. Only proceed if you expect this'
  ),
  i18nKey(
    'This transaction also sends a separate payment to whoever broadcasts it, as a "gas refund", on top of what is shown above. Only proceed if you expect this'
  ),
  i18nKey('Part of this batch could not be read and is not shown above. Proceed with caution'),
  i18nKey('Modules can execute transactions if conditions are met'),
  i18nKey('Owner & threshold configuration changes detected'),
  i18nKey('Owner configuration changes detected'),
  i18nKey('Threshold configuration changes detected'),
  i18nKey(
    'This adds new functionality to your account from a contract that is not a Safe default. Only proceed if you trust its source'
  ),
  i18nKey(
    'This lets the app perform several actions using your account, one after another, without asking you to confirm each one separately. Only proceed if you trust it'
  ),
  i18nKey(
    'This lets the contract above approve certain actions on behalf of your account automatically, without asking you each time. Only proceed if you trust it'
  ),
  i18nKey(
    'You are about to delegate permissions to a contract not whitelisted by Safe. Proceed with caution'
  )
] as const

// Row labels of the ERC-7730 descriptors bundled with ZKX (plus the "Send" row the library adds
// for an undisplayed native value). Labels from other descriptors are shown in English.
export const ERC7730_FIELD_LABELS = [
  i18nKey('Amount to Send'),
  i18nKey('Maximum to Send'),
  i18nKey('Minimum to Receive'),
  i18nKey('Amount to Receive'),
  i18nKey('Amount to Deposit'),
  i18nKey('Beneficiary'),
  i18nKey('Amount to Stake'),
  i18nKey('Stake Length (days)'),
  i18nKey('Stake ID'),
  i18nKey('Send')
] as const

// Intents of the bundled descriptors, in the template form `buildHumanizerTemplate` gives a
// single action word.
export const ERC7730_INTENT_TEMPLATES = [
  i18nKey('<0>Swap</0>'),
  i18nKey('<0>Add Liquidity</0>'),
  i18nKey('<0>Remove Liquidity</0>'),
  i18nKey('<0>Start Stake</0>'),
  i18nKey('<0>End Stake</0>')
] as const

const FIELD_LABELS = new Set<string>(ERC7730_FIELD_LABELS)

export const isKnownErc7730FieldLabel = (label: string) => FIELD_LABELS.has(label)
